// extracted by mini-css-extract-plugin
module.exports = {"dateContainer":"CreditCardExpiryDate_dateContainer__1jqK2","date":"CreditCardExpiryDate_date__2Sb3t"};